<template>
    <div class="vanguard-payment-method-switch">
        <input type="radio" name="payment" id="vanguard-payment-method-switch-sepa" v-model="paymentMethodLocale" :value="constants.PAYMENT_METHOD_SEPA" />
        <input type="radio" name="payment" id="vanguard-payment-method-switch-bank-card" v-model="paymentMethodLocale" :value="constants.PAYMENT_METHOD_BANK_CARD"/>
        <label for="vanguard-payment-method-switch-sepa" class="vanguard-payment-method-switch-sepa"></label>
        <label for="vanguard-payment-method-switch-bank-card" class="vanguard-payment-method-switch-bank-card">{{ Utils.capitalizeFirstLetter($t("all.bank_card")) }}</label>
        <div class="vanguard-payment-method-switch-indicator"></div>
	</div>
</template>
<script>
import {mapGetters} from 'vuex';
import Utils from '../modules/utils';

import * as mutations from '../store/mutations';
import * as constants from '../constants';

export default {
  data() {
    return {
      constants,
      paymentMethodLocale: '',
      appType: window.App.type
    };
  },
  computed: {
    ...mapGetters([
      'displayMode',
      'paymentMethod'
    ]),
    Utils() {
      return Utils;
    }
  },
  created() {
    this.paymentMethodLocale = this.$store.getters.paymentMethod;
  },
  watch: {
    paymentMethod(value) {
      this.paymentMethodLocale = value;
    },
    paymentMethodLocale(value) {
      // Update payment method in store with local value
      this.$store.commit(mutations.SET_PAYMENT_METHOD, value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// payment-switch-button.vue?30c4aac8